module.exports = __webpack_public_path__ + "media/scanOk.ba95b09f.wav";